import { Injectable } from "@angular/core"
import { AppConstants } from "../data-models/app-constants"
import { NavTab, PCSTab } from "../../store/project-details/project-details.state"
import { PCSSizerSerive } from "./pcsizer.service";
import { Internal } from "../decorators/app.decorators";

@Internal()
@Injectable({
    providedIn: 'root',
})

export class SideNavService {


    constructor(public pcsService: PCSSizerSerive){

    }
    standardTabs: Array<NavTab> = [{
        id: AppConstants.projectDetails,
        panel: 'project-details-panel',
        label: "Project Details",
        selected: true,
        disabled: false
    },
    {
        id: AppConstants.wldDomainSizing,
        panel: 'wld-domain-sizing-panel',
        label: 'Workload Domain Sizing',
        selected: false,
        disabled: true
    },
    {
        id: AppConstants.mgntDomainSizing,
        panel: 'mgnt-domain-sizing-panel',
        label: 'Management Domain Sizing',
        selected: false,
        disabled: true
    },
    {
        id: AppConstants.outputRecommendation,
        panel: 'output-recomm-panel',
        label: 'Recommendation Summary',
        selected: false,
        disabled: true
    }]

    standardBFTabs: Array<NavTab> = [
        {
            id: AppConstants.projectDetails,
            panel: 'project-details-panel',
            label: "Project Details",
            selected: true,
            disabled: false
        },
        {
            id: AppConstants.mgntDomainSizing,
            panel: 'mgnt-domain-sizing-panel',
            label: 'Management Domain Sizing',
            selected: false,
            disabled: false
        },
        {
            id: AppConstants.wldDomainSizing,
            panel: 'wld-domain-sizing-panel',
            label: 'Workload Domain Sizing',
            selected: false,
            disabled: false
        },
        {
            id: AppConstants.outputRecommendation,
            panel: 'output-recomm-panel',
            label: 'Recommendation Summary',
            selected: false,
            disabled: false
        }
    ];


    consolidatedTabs: Array<NavTab> = [
        {
            id: AppConstants.projectDetails,
            panel: 'project-details-panel',
            label: "Project Details",
            selected: true,
            disabled: false
        },
        {
            id: AppConstants.mgntDomainSizing,
            panel: 'mgnt-domain-sizing-panel',
            label: 'Management Domain Sizing',
            selected: false,
            disabled: false
        },
        {
            id: AppConstants.outputRecommendation,
            panel: 'output-recomm-panel',
            label: 'Recommendation Summary',
            selected: false,
            disabled: false
        }
    ];

    tabs: Array<PCSTab> = [
        {
            architecture: "standard",
            deployment: "greenfield",
            tabs: this.standardTabs
        },
        {
            architecture: "consolidated",
            deployment: "greenfield",
            tabs: this.consolidatedTabs
        },
        {
            architecture: "standard",
            deployment: "brownfield",
            tabs: this.standardBFTabs
        },
        {
            architecture: "consolidated",
            deployment: "brownfield",
            tabs: this.consolidatedTabs
        }
    ];

    getSideNavTabs(architecture: string, deployment: string): PCSTab{
        let tabs = this.tabs.find(ele => ele.deployment == deployment && ele.architecture == architecture)
        return tabs?JSON.parse(JSON.stringify(tabs)):{tabs:[]};
    }

    getInitState(): Array<NavTab>{
        return [{
            id: AppConstants.projectDetails,
            label: "Project Details",
            selected: true,
            panel: 'project-details-panel',
            disabled: false
          }]
    }
}